import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import { Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { OUTCOMES } from "../../../constants";

export enum Outcomes {
  yes = "yes",
  no = "no",
  dont_know = "dont_know",
}

interface Values {
  courtCaseReceived: string;
  caseNumber: string;
}

interface Props {
  screenData?: Record<string, string | number | boolean>[];
}

export const CourtCaseNumber = ({ screenData }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  console.log(`${currentScreen} screenData: ${JSON.stringify(screenData)}`);

  const courtCaseReceived =
    (screenData?.length && (screenData[0]?.courtCaseReceived as string)) || "";
  const caseNumber =
    (screenData?.length && (screenData[0]?.caseNumber as string)) || "";

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      courtCaseReceived,
      caseNumber,
    },
    schema: Yup.object().shape({
      courtCaseReceived: Yup.string().required("Please select an option"),
      caseNumber: Yup.string(),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    debugger;
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database
      // console.log(`values: ${JSON.stringify(values)}`);

      // TODO: fix
      const saved = await noticeToCreditorsFlow.saveData(currentScreen, 0, {
        receivedLetters: values.courtCaseReceived,
      });
      console.log(`saved: ${saved}`);

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Is there a court case file for the estate?"
      subTitle="An estate number is typically found in a court case file."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          // touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <RadioGroup
                  aria-label="courtCaseReceived"
                  name="courtCaseReceived"
                  value={values.courtCaseReceived}
                  onBlur={handleBlur}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value={Outcomes.yes}
                    control={<Radio />}
                    label="Yes"
                  />
                  {values.courtCaseReceived === Outcomes.yes && (
                    <TextField
                      fullWidth
                      label="Estate number"
                      margin="normal"
                      name="caseNumber"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="number"
                      value={values.caseNumber}
                      variant="outlined"
                    />
                  )}
                  <FormControlLabel
                    value={Outcomes.no}
                    control={<Radio />}
                    label="No"
                  />
                  <FormControlLabel
                    value={Outcomes.dont_know}
                    control={<Radio />}
                    label="I don't know"
                  />
                </RadioGroup>
                <Typography variant="body1" color="error">
                  {errors.courtCaseReceived}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
